module.exports = __webpack_public_path__ + "img/bingo_ball-60.08a5d404.png";